import { BILLING_FREQUENCY_LABEL } from '@/const/shared';
import { Box } from '@/components/Box/Box';
import {
  DashedLine,
  OverageRateBlock,
} from '@/bundle/Auth/AdminOnboardingFlow/SelectBillingPlanPage/ui/PricingPlanCard/styles';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { PlanCardInfoRow } from '@/bundle/Auth/AdminOnboardingFlow/SelectBillingPlanPage/ui/PlanCardInfoRow/PlanCardInfoRow';
import { convertCentsToDollars } from '@/helpers/formatHelpers';
import { NavigationLink } from '@/components/NavigationLink/NavigationLink';
import { getSelectBillingPlanPath } from '@/bundle/Auth/AdminOnboardingFlow/SelectBillingPlanPage/path';
import { CardDetailsWrapper } from '@/bundle/_MasterAdmin/_BillingPage/ui/styles';
import { BillingPlanType } from '@/api/v1/billing/getBillingPlanDetailsApi';
import {
  getEnableVerificationText,
  getOveragePriceText,
  getPaymentsLimitText,
  getPlanPrice,
  getUsersLimitText,
} from '../../SelectBillingPlanPage/helpers';
import { isSingleUsePaymentPlan } from '@/helpers/billingHelpers';

type SubscriptionPlanInfoCardType = {
  plan: BillingPlanType;
};

export const SubscriptionPlanInfoCard = ({ plan }: SubscriptionPlanInfoCardType) => {
  if (!plan) return;

  const {
    name,
    billing_frequency,
    max_users,
    monthly_views,
    extra_view_price_amount,
    enabled_id_verification,
    schedule_type,
  } = plan;
  const singleUsePaymentPlan = isSingleUsePaymentPlan(schedule_type);
  const billedPeriod = `billed ${BILLING_FREQUENCY_LABEL[billing_frequency]}`;
  const overagePrice = convertCentsToDollars(extra_view_price_amount, 2);
  const planPrice = getPlanPrice(plan);

  return (
    <CardDetailsWrapper>
      <Box display='flex' flexDirection='column'>
        <Box display='flex' flexDirection='column' marginBottom='16px'>
          <Box display='flex' flexDirection='column'>
            <Box width='100%' display='flex' alignItems='center' justifyContent='space-between'>
              <Typography variant='headline4' color={COLORS.black} fontWeight='semibold'>
                {name}
              </Typography>
              <Typography variant='headline3' color={COLORS.green[450]} fontWeight='semibold'>
                {planPrice}
              </Typography>
            </Box>
            {!singleUsePaymentPlan && (
              <Typography variant='caption' color={COLORS.grey[650]} fontWeight='medium'>
                {billedPeriod}
              </Typography>
            )}
          </Box>
        </Box>
        <DashedLine />

        <Box display='flex' flexDirection='column' rowGap='8px' paddingTop='14px' paddingBottom='20px'>
          <PlanCardInfoRow>{getPaymentsLimitText(monthly_views)}</PlanCardInfoRow>
          <PlanCardInfoRow>{getUsersLimitText(max_users)}</PlanCardInfoRow>
          <PlanCardInfoRow>{getEnableVerificationText(enabled_id_verification)}</PlanCardInfoRow>
        </Box>

        <OverageRateBlock>{getOveragePriceText(overagePrice)}</OverageRateBlock>
        <Box display='flex' alignItems='center' justifyContent='center' marginTop='16px'>
          <NavigationLink to={getSelectBillingPlanPath()}>Change Plan</NavigationLink>
        </Box>
      </Box>
    </CardDetailsWrapper>
  );
};
